export default class MedicalDataTextarea {
  constructor(label, property, propertyName) {
    this.label = label;
    this.property = property;
    this.propertyName = propertyName;
  }
}
